import { ReorderList, type ReorderItem } from '@/components/shared/reorder-list';
import type { LearningPathItem } from '@/data/learning-path/interfaces';

interface ReorderPathsProps {
  paths: LearningPathItem[];
  updatePaths: (paths: LearningPathItem[]) => void;
}

export const ReorderPaths = ({ paths, updatePaths }: ReorderPathsProps) => {
  const handleReorder = (items: ReorderItem[]) => {
    const reordered = items.map(
      (item) => paths.find((p) => p.id === item.id)!
    );
    updatePaths(reordered);
  };

  return <ReorderList items={paths} onReorder={handleReorder} />;
};
